import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Building, Factory, HardHat, Home, Wrench, ShieldAlert } from 'lucide-react';

const IndustriesPage = () => {
  const industries = [
    {
      icon: Building,
      title: 'Commercial Construction',
      desc: 'Supplying foundational materials, electrical systems, and finishing products for high-rise buildings, malls, and commercial complexes.'
    },
    {
      icon: HardHat,
      title: 'MEP Contractors',
      desc: 'A complete range of Mechanical, Electrical, and Plumbing (MEP) supplies. From robust PVC pipes to advanced automation panels.'
    },
    {
      icon: Factory,
      title: 'Manufacturing & Industrial',
      desc: 'Heavy-duty power tools, safety equipment, and specialized hardware designed to keep industrial operations running smoothly.'
    },
    {
      icon: Home,
      title: 'Residential Development',
      desc: 'Premium sanitaryware, lighting, and paints tailored for villas, townhouses, and luxury residential projects.'
    },
    {
      icon: ShieldAlert,
      title: 'Oil & Gas',
      desc: 'High-grade safety gear, PPE, and specialized tools that meet the stringent compliance and safety standards of the energy sector.'
    },
    {
      icon: Wrench,
      title: 'Facility Management',
      desc: 'Consumables, maintenance tools, and repair hardware to support the ongoing operations of large facilities and estates.'
    }
  ];

  return (
    <div className="min-h-screen bg-background pb-20">
      {/* Header Banner */}
      <div className="bg-[#0c1b44] text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" />
        <div className="container mx-auto px-4 text-center relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Industries We Serve</h1>
          <p className="text-gray-300 max-w-2xl mx-auto text-lg leading-relaxed">
            Grand Palace General Trading provides specialized material solutions across diverse sectors, understanding the unique requirements of each industry.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16 max-w-7xl">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry, idx) => (
            <Card key={idx} className="border-0 shadow-md overflow-hidden group">
              <div className="h-2 bg-gradient-to-r from-[#0c1b44] to-gold transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
              <CardContent className="p-8">
                <div className="w-16 h-16 rounded-2xl bg-gray-50 flex items-center justify-center mb-6">
                  <industry.icon className="h-8 w-8 text-gold" />
                </div>
                <h3 className="text-xl font-bold text-navy mb-3">{industry.title}</h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  {industry.desc}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IndustriesPage;
